import { FC } from 'react';
import { Grid, Typography, Box, useMediaQuery } from '@mui/material';
import useTranslations from '../global/translation/hooks/translation';
import { useTheme } from '@mui/material/styles';
import { useThemeContext } from '../global/ThemeContext';

const Selectivity: FC = () => {
  const { currentLanguage, translations } = useTranslations();
  const theme = useTheme();
  const { darkMode } = useThemeContext();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="flex-start"
      sx={{
        bgcolor: darkMode ? '#1a1a1f' : '#FFFFFF',
        py: isMobile ? 6 : 10,
        px: isMobile ? 3 : 4,
      }}
    >
      {/* Section Title */}
      <Grid item xs={12} sx={{ mb: 6, textAlign: 'center', maxWidth: '900px' }}>
        <Typography
          variant="h4"
          fontWeight={300}
          sx={{
            color: darkMode ? '#FFFFFF' : '#000000',
            mb: 2,
            letterSpacing: '-0.5px',
          }}
        >
          {translations.label.forWhomTitle[currentLanguage]}
        </Typography>
      </Grid>

      {/* Two Column Layout */}
      <Grid container spacing={isMobile ? 4 : 6} sx={{ maxWidth: '1000px', mx: 'auto' }}>
        {/* For Whom */}
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              borderLeft: '2px solid',
              borderColor: theme.palette.primary.main,
              pl: 3,
              py: 2,
            }}
          >
            <Typography
              variant="h5"
              fontWeight={400}
              sx={{
                color: theme.palette.primary.main,
                mb: 2,
                letterSpacing: '-0.3px',
              }}
            >
              ✓ {translations.label.forWhomTitle[currentLanguage]}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: darkMode ? '#CCCCCC' : '#555555',
                lineHeight: 1.8,
                fontSize: '15px',
              }}
            >
              {translations.label.forWhomText[currentLanguage]}
            </Typography>
          </Box>
        </Grid>

        {/* Not For Whom */}
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              borderLeft: '2px solid',
              borderColor: darkMode ? '#444444' : '#DDDDDD',
              pl: 3,
              py: 2,
            }}
          >
            <Typography
              variant="h5"
              fontWeight={400}
              sx={{
                color: darkMode ? '#999999' : '#999999',
                mb: 2,
                letterSpacing: '-0.3px',
              }}
            >
              ✕ {translations.label.notForWhomTitle[currentLanguage]}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: darkMode ? '#999999' : '#888888',
                lineHeight: 1.8,
                fontSize: '15px',
                fontStyle: 'italic',
              }}
            >
              {translations.label.notForWhomText[currentLanguage]}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Selectivity;
